class ProductMarkers {
	constructor(container) {
		this.container = container;
		this.swiperContainer = container.querySelector('.product-markers__swiper');
		this.markers = container.querySelectorAll('.js-product-markers__item');
		this.slides = container.querySelectorAll('.swiper-slide');

		this.init();
	}

	init() {
		const swiperContainer = this.container.querySelector('.product-markers__swiper');
		const markers = this.container.querySelectorAll('.js-product-markers__item');
		const slides = this.container.querySelectorAll('.swiper-slide');

		if (!swiperContainer || !markers.length) return;

		const swiper = new Swiper(swiperContainer, {
			slidesPerView: 1.5,
			spaceBetween: 16,
			grabCursor: true,
			freeMode: {
				enabled: true,
				sticky: false,
				momentum: true
			},
			pagination: {
				el: this.container.querySelector('.swiper-pagination'),
				clickable: true,
			},
			navigation: {
				nextEl: this.container.querySelector('.swiper-button-next'),
        prevEl: this.container.querySelector('.swiper-button-prev'),
			},
			breakpoints: {
				576: {
					slidesPerView: 2.2,
				},
				768: {
					slidesPerView: 2.6,
				},
				990: {
					slidesPerView: 2,
					spaceBetween: 24,
					freeMode: {
						enabled: false
					}
				}
			},
			on: {
				slideChange: function() {
					updateActiveMarker(this.activeIndex);
				}
			}
		});

		function updateActiveMarker(activeIndex) {
			markers.forEach((marker, index) => {
				marker.classList.toggle('active', index === activeIndex);
			});
		}

		markers.forEach((marker, index) => {
			if (marker.dataset.handlerAdded === 'true') return;
			marker.dataset.handlerAdded = 'true';

			marker.addEventListener('click', (e) => {
				e.preventDefault();
				e.stopPropagation();
				
				swiper.slideTo(index);
				
				markers.forEach(m => m.classList.remove('active'));
				marker.classList.add('active');
				
				updateActiveSlide(index);
			});
		});

		function updateActiveSlide(activeIndex) {
			slides.forEach((slide, index) => {
				slide.classList.toggle('active-slide', index === activeIndex);
			});
		}

		slides.forEach((slide, index) => {
			slide.addEventListener('mouseenter', () => {
				markers.forEach(m => m.classList.remove('active'));
				slides.forEach(s => s.classList.remove('active-slide'));

				if (markers[index]) {
					markers[index].classList.add('active');
				}

				slide.classList.add('active-slide');
			});

			slide.addEventListener('mouseleave', () => {
				if (markers[index]) {
					markers[index].classList.remove('active');
				}
				slide.classList.remove('active-slide');
			});
		});

		// Set initial active marker
		updateActiveMarker(0);
		updateActiveSlide(0);

		// Handle clicks outside markers
		document.addEventListener('click', (e) => {
			if (!e.target.closest('.product-markers') && !e.target.closest('.js-product-markers__item')) {
				markers.forEach(marker => {
					marker.classList.remove('active');
				});
				slides.forEach(slide => {
					slide.classList.remove('active-slide');
				});
			}
		});

		// Store swiper instance for potential cleanup
		swiperContainer.swiperInstance = swiper;
	};
}

// Initialize tabs when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  const productMarkersContainers = document.querySelectorAll('.product-markers');
  productMarkersContainers.forEach(container => {
    new ProductMarkers(container);
  });
});